"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Steps = exports.StepContainer = exports.StepBreak = exports.Step = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _coreListItem = _interopRequireDefault(require("@vfuk/core-list-item"));

var _coreListGroup = _interopRequireDefault(require("@vfuk/core-list-group"));

var _coreSpan = _interopRequireDefault(require("@vfuk/core-span"));

var _coreMixins = require("@vfuk/core-mixins");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Steps = (0, _styledComponents["default"])(_coreListGroup["default"]).withConfig({
  displayName: "SubPaginatorstyle__Steps",
  componentId: "sc-128sft1-0"
})(function () {
  return (0, _styledComponents.css)(["width:100%;display:flex;align-items:center;"]);
});
exports.Steps = Steps;
var StepContainer = (0, _styledComponents["default"])(_coreListItem["default"]).withConfig({
  displayName: "SubPaginatorstyle__StepContainer",
  componentId: "sc-128sft1-1"
})(function () {
  return (0, _styledComponents.css)(["display:flex;justify-content:center;margin:0 2px;"]);
});
exports.StepContainer = StepContainer;
var StepBreak = (0, _styledComponents["default"])(_coreListItem["default"]).withConfig({
  displayName: "SubPaginatorstyle__StepBreak",
  componentId: "sc-128sft1-2"
})(function () {
  return (0, _styledComponents.css)(["display:flex;justify-content:center;", ";"], (0, _coreMixins.responsiveSizing)('width', 6));
});
exports.StepBreak = StepBreak;
var Step = (0, _styledComponents["default"])(_coreSpan["default"]).withConfig({
  displayName: "SubPaginatorstyle__Step",
  componentId: "sc-128sft1-3"
})(function (props) {
  var _props$paginatorTheme = props.paginatorTheme.appearance[props.appearance],
      stepBorder = _props$paginatorTheme.stepBorder,
      stepBgColor = _props$paginatorTheme.stepBgColor,
      currentStep = _props$paginatorTheme.currentStep;
  return (0, _styledComponents.css)(["display:flex;align-items:center;justify-content:center;background-color:", ";border:", ";", ";", ";text-align:center;transition:background-color 0.3s ease,border-color 0.3s ease;", ""], stepBgColor, stepBorder, (0, _coreMixins.responsiveSizing)('width', 7), (0, _coreMixins.responsiveSizing)('height', 7), props.isCurrentStep && (0, _styledComponents.css)(["background-color:", ";color:", ";border:", ";"], currentStep.bgColor, currentStep.color, currentStep.border));
});
exports.Step = Step;
//# sourceMappingURL=SubPaginator.style.js.map